export enum ContentType {
  storyHub = 'STORY',
  library = 'STORY_VIDEO'
}
